<template>
	<a-modal
		class="g-qrcode-nav-edit-modal"
		:visible="visible"
		title="链接模块编辑"
		width="730px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
		<div class="g-qrcode-nav-edit">
			<div class="g-qrcode-nav-edit__stage">
				<div class="g-qrcode-nav-edit__preview-box" :class="{ 'is-nav': isImageNavMode || isBannerMode }">
					<template v-if="isCardMode">
						<div class="g-qrcode-nav-edit__card-preview" :style="previewCardStyle">
							<div class="g-qrcode-nav-edit__card-header">
								<div v-if="form.showImage" class="g-qrcode-nav-edit__cell-thumb">
									<img v-if="navImageUrl" :src="navImageUrl" alt="" />
									<i v-else class="mbm-iconfont mbm-tupian"></i>
								</div>
								<input
									v-model="form.title"
									type="text"
									class="g-qrcode-nav-edit__card-title"
									:style="{ color: form.titleColor }"
									maxlength="40"
									placeholder="LOUXOR卢索系列"
								/>
							</div>
							<textarea
								v-model="form.description"
								class="g-qrcode-nav-edit__card-desc"
								:style="{ color: form.detailColor }"
								rows="3"
								maxlength="200"
								placeholder="请输入详情描述"
							></textarea>
							<div class="g-qrcode-nav-edit__card-footer">
								<div class="g-qrcode-nav-edit__card-divider"></div>
								<input
									v-model="form.actionText"
									type="text"
									class="g-qrcode-nav-edit__card-action"
									:style="{ color: form.detailColor }"
									maxlength="12"
									placeholder="了解更多"
								/>
							</div>
						</div>
					</template>
					<template v-else-if="isBannerMode">
						<div class="g-qrcode-nav-edit__banner-preview" :style="previewBannerStyle">
							<div class="g-qrcode-nav-edit__banner-main">
								<input
									v-model="form.title"
									type="text"
									class="g-qrcode-nav-edit__banner-title"
									maxlength="40"
									placeholder="智能巡检解决方案"
								/>
								<textarea
									v-model="form.description"
									class="g-qrcode-nav-edit__banner-desc"
									rows="2"
									maxlength="200"
									placeholder="请输入详情描述"
								></textarea>
							</div>
							<div class="g-qrcode-nav-edit__banner-arrow">
								<i class="mbm-iconfont mbm-youjiantou"></i>
							</div>
						</div>
					</template>
					<template v-else-if="isCellMode">
						<div class="g-qrcode-nav-edit__cell-preview" :style="previewCellStyle">
							<div v-if="form.showImage" class="g-qrcode-nav-edit__cell-thumb">
								<img v-if="navImageUrl" :src="navImageUrl" alt="" />
								<i v-else class="mbm-iconfont mbm-tupian"></i>
							</div>
							<input
								v-model="form.title"
								type="text"
								class="g-qrcode-nav-edit__cell-title"
								maxlength="40"
								placeholder="米家电热水壶使用说明"
							/>
							<div class="g-qrcode-nav-edit__cell-action">
								<input
									v-model="form.actionText"
									type="text"
									class="g-qrcode-nav-edit__cell-action-input"
									maxlength="12"
									placeholder="点击查看"
								/>
								<i class="mbm-iconfont mbm-youjiantou"></i>
							</div>
						</div>
					</template>
					<template v-else>
						<input
							v-model="form.buttonText"
							type="text"
							class="g-qrcode-nav-edit__preview-btn"
							:style="previewButtonStyle"
							maxlength="20"
							placeholder="查看详情"
						/>
					</template>
				</div>

				<div class="g-qrcode-nav-edit__panel g-qrcode-nav-edit__panel--arrow">
					<div class="g-qrcode-nav-edit__link-row">
						<i class="mbm-iconfont mbm-lianjie"></i>
						<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
					</div>

					<div class="g-qrcode-nav-edit__toolbar">
						<template v-if="isImageNavMode">
							<button type="button" class="g-qrcode-nav-edit__action" @click="triggerImageSelect">换图</button>
							<button type="button" class="g-qrcode-nav-edit__action" @click="toggleHideImage">
								{{ form.showImage ? '隐藏图片' : '显示图片' }}
							</button>
							<button type="button" class="g-qrcode-nav-edit__action" @click="jumpLinkVisible = true">换链接</button>
						</template>
						<template v-else-if="isBannerMode">
							<button type="button" class="g-qrcode-nav-edit__action" @click="jumpLinkVisible = true">换链接</button>
						</template>
						<template v-else>
							<button type="button" class="g-qrcode-nav-edit__action" @click="jumpLinkVisible = true">换链接</button>
							<span class="g-qrcode-nav-edit__action-wrap">
								<button
									type="button"
									class="g-qrcode-nav-edit__action"
									:class="{ 'is-active': activePanel === 'width' }"
									@click="togglePanel('width')"
								>长度</button>
								<div v-if="activePanel === 'width'" class="g-qrcode-nav-edit__sub-panel">
									<span class="g-qrcode-nav-edit__sub-label">长度 (px)</span>
									<a-input-number
										v-model:value="widthDraft"
										:min="0"
										:max="600"
										:precision="0"
										class="g-qrcode-nav-edit__sub-input"
									/>
									<button type="button" class="g-qrcode-nav-edit__sub-confirm" @click="applyWidth">确定</button>
								</div>
							</span>
						</template>
						<span class="g-qrcode-nav-edit__action-wrap">
							<button
								type="button"
								class="g-qrcode-nav-edit__action"
								:class="{ 'is-active': activePanel === 'radius' }"
								@click="togglePanel('radius')"
							>圆角</button>
							<div v-if="activePanel === 'radius'" class="g-qrcode-nav-edit__sub-panel">
								<span class="g-qrcode-nav-edit__sub-label">圆角 (px)</span>
								<a-input-number
									v-model:value="radiusDraft"
									:min="0"
									:max="100"
									:precision="0"
									class="g-qrcode-nav-edit__sub-input"
								/>
								<button type="button" class="g-qrcode-nav-edit__sub-confirm" @click="applyRadius">确定</button>
							</div>
						</span>

						<div class="g-qrcode-nav-edit__colors">
							<template v-if="isCardMode">
								<ColorPicker
									v-model="form.titleColor"
									title="标题颜色"
									@change="onTitleColorInput"
								/>
								<ColorPicker
									v-model="form.detailColor"
									title="详情文字颜色"
									@change="onDetailColorInput"
								/>
							</template>
							<template v-else-if="isBannerMode">
								<ColorPicker
									v-model="form.bgColor"
									title="背景色"
									@change="onBgColorInput"
								/>
								<ColorPicker
									v-model="form.textColor"
									title="文字颜色"
									@change="onTextColorInput"
								/>
							</template>
							<template v-else>
								<ColorPicker
									v-if="showBgColor"
									v-model="form.bgColor"
									title="背景色"
									@change="onBgColorInput"
								/>
								<ColorPicker
									v-model="form.textColor"
									:title="showBgColor ? '文字颜色' : '文字和边框颜色'"
									@change="onTextColorInput"
								/>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>

		<input
			ref="imageInput"
			type="file"
			accept="image/*"
			class="g-qrcode-nav-edit__file-input"
			@change="onImageSelect"
		/>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" class="g-qrcode-nav-edit-modal__ok" @click="onConfirm">确定</a-button>
		</template>

		<JumpLink
			:visible="jumpLinkVisible"
			:jumpLink="form.jumpLink || emptyJumpLink"
			:linkTypes="['qrcode']"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>
	</a-modal>
</template>

<script>
	import JumpLink from '@/components/jumpLink.vue';
	import ColorPicker from './ColorPicker.vue';
	import { createEmptyJumpLink, formatJumpLinkLabel } from '../utils/jumpLink.js';
	import {
		isLocalImageFile,
		MAX_LOCAL_IMAGE_SIZE,
	} from '../utils/localImage.js';
	import {
		getQrcodeNavBannerStyle,
		getQrcodeNavButtonStyle,
		getQrcodeNavCardStyle,
		getQrcodeNavCellStyle,
		getQrcodeNavImageUrl,
		isQrcodeNavBannerBlock,
		isQrcodeNavCardBlock,
		isQrcodeNavCellBlock,
		isQrcodeNavImageBlock,
		normalizeQrcodeNavData,
		replaceQrcodeNavCellImage,
		QRCODE_NAV_TYPES,
	} from '../utils/qrcodeNav.js';
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import { uploadHeaderMediaFiles } from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GQrcodeNavEditModal',
		components: { JumpLink, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			blockType: {
				type: String,
				default: QRCODE_NAV_TYPES.solid,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: normalizeQrcodeNavData(QRCODE_NAV_TYPES.solid, {}),
				jumpLinkVisible: false,
				emptyJumpLink: createEmptyJumpLink(),
				activePanel: '',
				widthDraft: 0,
				radiusDraft: 4,
				isUploading: false,
			};
		},
		computed: {
			isCellMode() {
				return isQrcodeNavCellBlock(this.blockType);
			},
			isCardMode() {
				return isQrcodeNavCardBlock(this.blockType);
			},
			isBannerMode() {
				return isQrcodeNavBannerBlock(this.blockType);
			},
			isImageNavMode() {
				return isQrcodeNavImageBlock(this.blockType);
			},
			showBgColor() {
				return this.isBannerMode || (!this.isCardMode && this.blockType !== QRCODE_NAV_TYPES.outline);
			},
			jumpLinkLabel() {
				return formatJumpLinkLabel(this.form.jumpLink);
			},
			previewButtonStyle() {
				return getQrcodeNavButtonStyle(this.blockType, this.form);
			},
			previewCellStyle() {
				return getQrcodeNavCellStyle(this.blockType, this.form);
			},
			previewCardStyle() {
				return getQrcodeNavCardStyle(this.blockType, this.form);
			},
			previewBannerStyle() {
				return getQrcodeNavBannerStyle(this.blockType, this.form);
			},
			navImageUrl() {
				return getQrcodeNavImageUrl(this.form.image);
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.syncForm();
				} else {
					this.activePanel = '';
				}
			},
			blockType() {
				if (this.visible) {
					this.syncForm();
				}
			},
			data: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			syncForm() {
				this.form = normalizeQrcodeNavData(this.blockType, this.data);
				this.widthDraft = this.form.buttonWidth || 0;
				this.radiusDraft = this.form.borderRadius;
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'width') {
					this.widthDraft = this.form.buttonWidth || 0;
				}
				if (panel === 'radius') {
					this.radiusDraft = this.form.borderRadius;
				}
			},
			applyWidth() {
				this.form.buttonWidth = Math.max(0, Number(this.widthDraft) || 0);
				this.activePanel = '';
			},
			applyRadius() {
				this.form.borderRadius = Math.max(0, Number(this.radiusDraft) || 0);
				this.activePanel = '';
			},
			onBgColorInput(color) {
				this.form.bgColor = color;
			},
			onTextColorInput(color) {
				this.form.textColor = color;
			},
			onTitleColorInput(color) {
				this.form.titleColor = color;
			},
			onDetailColorInput(color) {
				this.form.detailColor = color;
			},
			onJumpLinkSubmit(link) {
				this.form.jumpLink = { ...link };
				this.jumpLinkVisible = false;
			},
			triggerImageSelect() {
				this.$refs.imageInput?.click();
			},
			async onImageSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !isLocalImageFile(file)) return;
				if (file.size > MAX_LOCAL_IMAGE_SIZE) return;
				this.isUploading = true;
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
					});
					this.form.image = replaceQrcodeNavCellImage(this.form.image, file, () => item);
					this.form.showImage = true;
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
				}
			},
			toggleHideImage() {
				this.form.showImage = !this.form.showImage;
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const payload = normalizeQrcodeNavData(this.blockType, {
					...this.form,
					buttonText: this.form.buttonText?.trim() || '查看详情',
					title: this.form.title?.trim() || (
						this.isBannerMode
							? '智能巡检解决方案'
							: (this.isCardMode ? 'LOUXOR卢索系列' : '米家电热水壶使用说明')
					),
					description: this.form.description?.trim() || (
						this.isBannerMode
							? '一物一码，一台手机就能查看最新档案；设备档案管理、报修、巡检、保养，全流程覆盖。'
							: ''
					),
					actionText: this.form.actionText?.trim() || (this.isCardMode ? '了解更多' : '点击查看'),
				});
				if (!payload.jumpLink?.type) {
					payload.jumpLink = null;
				}
				this.$emit('confirm', payload);
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.edit-float-panel(g-qrcode-nav-edit__panel);
	.edit-float-toolbar(g-qrcode-nav-edit__toolbar);
	.edit-float-action(g-qrcode-nav-edit__action);

	.g-qrcode-nav-edit {
		min-height: 360px;
		padding: 8px 0 12px;
	}

	.g-qrcode-nav-edit__stage {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 340px;
	}

	.g-qrcode-nav-edit__preview-box {
		position: relative;
		width: 100%;
		max-width: 520px;
		padding: 28px 24px;
		border: 1px dashed #285af9;
		border-radius: 2px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;

		&.is-nav {
			padding: 24px 20px;
		}
	}

	.g-qrcode-nav-edit__card-preview {
		width: 100%;
		padding: 14px 16px 12px;
		background: #fff;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		box-sizing: border-box;
	}

	.g-qrcode-nav-edit__banner-preview {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 88px;
		padding: 16px 18px;
		box-sizing: border-box;
	}

	.g-qrcode-nav-edit__banner-main {
		flex: 1;
		min-width: 0;
	}

	.g-qrcode-nav-edit__banner-title {
		display: block;
		width: 100%;
		border: none;
		outline: none;
		background: transparent;
		font-size: 17px;
		font-weight: 600;
		line-height: 1.4;
		margin-bottom: 6px;
		font-family: inherit;
		color: inherit;

		&::placeholder {
			color: rgba(255, 255, 255, 0.55);
		}
	}

	.g-qrcode-nav-edit__banner-desc {
		display: block;
		width: 100%;
		border: none;
		outline: none;
		resize: none;
		background: transparent;
		font-size: 12px;
		line-height: 1.6;
		font-family: inherit;
		color: inherit;
		opacity: 0.92;

		&::placeholder {
			color: rgba(255, 255, 255, 0.55);
		}
	}

	.g-qrcode-nav-edit__banner-arrow {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		border: 1px solid currentColor;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0.95;

		i {
			font-size: 12px;
			line-height: 1;
		}
	}

	.g-qrcode-nav-edit__card-header {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 12px;
	}

	.g-qrcode-nav-edit__card-title {
		flex: 1;
		min-width: 0;
		border: none;
		outline: none;
		background: transparent;
		font-size: 16px;
		font-weight: 600;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__card-desc {
		display: block;
		width: 100%;
		border: none;
		outline: none;
		resize: none;
		background: transparent;
		font-size: 13px;
		line-height: 1.7;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__card-footer {
		margin-top: 14px;
	}

	.g-qrcode-nav-edit__card-divider {
		height: 1px;
		background: #f0f0f0;
		margin-bottom: 10px;
	}

	.g-qrcode-nav-edit__card-action {
		display: block;
		width: 100%;
		border: none;
		outline: none;
		background: transparent;
		font-size: 13px;
		text-align: right;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__cell-preview {
		display: flex;
		align-items: center;
		gap: 12px;
		width: 100%;
		min-height: 56px;
		padding: 10px 14px;
		box-sizing: border-box;
	}

	.g-qrcode-nav-edit__cell-thumb {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
		background: #e8e8e8;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 18px;
			color: #bfbfbf;
		}
	}

	.g-qrcode-nav-edit__cell-title {
		flex: 1;
		min-width: 0;
		border: none;
		outline: none;
		background: transparent;
		font-size: 15px;
		font-weight: 500;
		color: inherit;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__cell-action {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		gap: 2px;
		opacity: 0.72;

		i {
			font-size: 12px;
			color: inherit;
		}
	}

	.g-qrcode-nav-edit__cell-action-input {
		width: 64px;
		border: none;
		outline: none;
		background: transparent;
		font-size: 13px;
		color: inherit;
		text-align: right;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__file-input {
		display: none;
	}

	.g-qrcode-nav-edit__preview-btn {
		max-width: 100%;
		outline: none;
		text-align: center;
		font-family: inherit;
	}

	.g-qrcode-nav-edit__panel {
		position: relative;
		display: inline-block;
		width: auto;
		max-width: 100%;
		margin-top: 12px;

		&--arrow::before {
			left: 50%;
			margin-left: -5px;
		}
	}

	.g-qrcode-nav-edit__link-row {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 40px;
		padding: 0 14px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 13px;
		color: #333;

		i {
			color: #999;
			font-size: 14px;
		}

		.is-empty {
			color: #999;
		}
	}

	.g-qrcode-nav-edit__action-wrap {
		position: relative;
		display: inline-flex;
		flex-shrink: 0;
	}

	.g-qrcode-nav-edit__action {
		&:hover,
		&.is-active {
			color: #1d4ed8;
		}
	}

	.g-qrcode-nav-edit__colors {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
		padding-left: 8px;
	}

	.g-qrcode-nav-edit__swatch {
		position: relative;
		display: inline-block;
		width: 18px;
		height: 18px;
		border: 1px solid #b0b0b0;
		border-radius: 3px;
		cursor: pointer;
		overflow: hidden;
		flex-shrink: 0;
		box-sizing: border-box;

		&:hover {
			box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.25);
		}
	}

	.g-qrcode-nav-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		opacity: 0;
		cursor: pointer;
	}

	.g-qrcode-nav-edit__sub-panel {
		position: absolute;
		left: 50%;
		top: calc(100% + 6px);
		z-index: 2;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 4px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		transform: translateX(-50%);
		white-space: nowrap;
	}

	.g-qrcode-nav-edit__sub-label {
		font-size: 13px;
		color: #666;
	}

	.g-qrcode-nav-edit__sub-input {
		width: 88px;
	}

	.g-qrcode-nav-edit__sub-confirm {
		height: 28px;
		padding: 0 12px;
		border: none;
		border-radius: 4px;
		background: #285af9;
		color: #fff;
		font-size: 12px;
		cursor: pointer;
		line-height: 28px;

		&:hover {
			background: #3868ff;
		}
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-qrcode-nav-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();

		.g-qrcode-nav-edit-modal__ok {

			&:hover,
			&:focus {
				background: #3868ff;
				border-color: #3868ff;
			}
		}
	}
</style>
